import CodeIcon from '@mui/icons-material/Code';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import HelpIcon from '@mui/icons-material/Help';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import StorageIcon from '@mui/icons-material/Storage';

export const marks = [
  {
    value: 0,
    label: '1h',
  },
  {
    value: 12.5,
    label: '2h',
  },
  {
    value: 25,
    label: '3h',
  },
  {
    value: 37.5,
    label: '4h',
  },
  {
    value: 50,
    label: '5h',
  },
  {
    value: 62.5,
    label: '6h',
  },
  {
    value: 75,
    label: '7h',
  },
  {
    value: 87.5,
    label: '8h',
  },
  {
    value: 100,
    label: '9h',
  },
];

export const techsList = [
  {
    title: 'Front-end web development',
    titleFr: 'Développement web front-end',
    name: 'frontend',
    placeholder: 'React Js, Vue Js...',
    icon: <DesignServicesIcon color="primary" />,
  },
  {
    title: 'Mobile development',
    titleFr: 'Développement mobile',
    name: 'mobile',
    placeholder: 'Flutter, React Native ...',
    icon: <DeveloperModeIcon color="primary" />,
  },
  {
    title: 'Back-end development',
    titleFr: 'Développement back-end',
    name: 'backend',
    placeholder: 'Node Js, Django...',
    icon: <IntegrationInstructionsIcon color="primary" />,
  },
  {
    title: 'Database',
    titleFr: 'Base de données',
    name: 'database',
    placeholder: 'Mongo DB, MySQL...',
    icon: <StorageIcon color="primary" />,
  },
  {
    title: 'Other programming languages',
    titleFr: 'Autres langages de programmation',
    name: 'others',
    placeholder: 'Rust, Go...',
    icon: <CodeIcon color="primary" />,
  },
  {
    title: 'Your stack of choice',
    titleFr: 'Le stack de votre choix',
    name: 'choice',
    placeholder: 'MERN Stack, MEVN Stack, MEAN Stack...',
    icon: <StackedBarChartIcon color="primary" />,
  },
  {
    title: 'Anything else of interest?',
    titleFr: 'Quelque chose d’autre d’intéressant?',
    name: 'anything',
    placeholder: 'DevOps, UI/UX Design',
    icon: <HelpIcon color="primary" />,
  },
];
